import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCheckCircle, faCircle} from '@fortawesome/free-solid-svg-icons'

import './seriesbutton.css'

export default function SeriesButton (props) {
  const marker = props?.on ?? true;
  const ficon = marker ? faCheckCircle : faCircle
  const action = props?.onClick ?? (() => {});
  const colour = props?.color ?? '#007ac0';
  return (
    <span className='series-button'>
      <FontAwesomeIcon size='2x' icon={ficon} color={colour} onClick={action} />
    </span>
  )
}
